export default __webpack_public_path__ + "static/media/video-institucional.18f1a699.mp4";